<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tenuta di Trinoro</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con un bell'aspetto da star del cinema, un pedigree di famiglia lungo quanto il tuo braccio e un libriccino nero
                        gonfio, saresti perdonato se pensi che il produttore della Tenuta di Trinoro Andrea Franchetti non sia il tuo viticoltore archetipico. Eppure, il suo vino di punta Tenuta di Trinoro aveva guadagnato legioni di fan. Una miscela bordolese che "anche i bordolesi ammettono che è meglio qui che a Bordeaux" Tenuta di Trinoro è il più vicino a xxxx che puoi ottenere senza essere effettivamente in Francia.
                    </div>

                    <div class="howto-title2">Una tenuta "dimenticata da Dio"</div>
                    <div class="howto-text">
                        Ex ristoratore, distributore di vino e “dopehead completo”, Franchetti è un viticoltore
                        piccolo principe. Piantando la tenuta nel 1992, la descrive come “un luogo abbandonato da Dio a est
                        della prima montagna calcarea a nord di Roma con un ex vulcano tra essa e il mare”. Essere
                        che come può, la posizione della tenuta situata in un anfiteatro naturale protegge le viti da
                        maltempo e permette a Franchetti di conservare i suoi frutti sulla vite molto più a lungo degli altri
                        concorrenti super-toscani. È questa lunga maturazione che dona alla Tenuta di Trinoro tanti
                        complessi strati di sapori, così amati dai moderni collezionisti di vino.
                    </div>

                    <div class="howto-title2">Palazzi, Tenuta e Cupole</div>
                    <div class="howto-text">
                        Molti critici enologici della vecchia scuola lamentano la fine del suo Palazzi, una deliziosa miscela di Merlot con
                        Cabernet Franc. Fantasticamente popolare negli Stati Uniti (il 1998 ha vinto 93 punti su 100 da
                        Il guru del vino americano Robert Parker), Franchetti ha smesso di produrlo nel 1999.”Palazzi era meno
                        complesso, quindi perché farlo? lui dice. Apparentemente, il successo non è abbastanza impegnativo per lui. Tenuta
                        di Trinoro potrebbe essere il numero uno della tenuta, ma il suo secondo vino Le Cupole di Trinoro non è la metà
                        neanche male. Un marcatore basso degli anni Novanta (quasi costantemente), basato sulla nostra qualità rispetto al prezzo, questo
                        il vino rappresenta un ottimo rapporto qualità-prezzo. Aumentando in popolarità se questo non è ancora
                        nel tuo portfolio, potresti prenderlo in considerazione sul tuo tavolo.
                        <br><br>
                        Tuttavia, se il tuo cuore appartiene ancora alla Tenuta, nota che è tra i più costosi
                        Vini Toscana IGT sul mercato secondario. Aspettatevi di pagare qualcosa nella regione di € 200 per
                        bottiglia, nettamente superiore agli altri vini della regione. A partire dal secondo trimestre del 2019, il prezzo era stato
                        stabile nell'ultimo anno.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Tenuta di Trinoro</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Mit dem guten Aussehen eines Filmstars, einem armlangen Familienstammbaum und einem kleinen schwarzen Buch
                        Wenn der Wein aus allen Nähten platzt, könnte man denken, dass Tenuta di Trinoro-Produzent Andrea Franchetti nicht der typische Weinbauer ist. Und doch hatte sein Flaggschiffwein Tenuta di Trinoro Legionen von Fans gewonnen. Eine Bordeaux-Mischung, von der „selbst die Bordelais zugeben, dass sie hier besser ist als in Bordeaux.“ Tenuta di Trinoro kommt xxxx so nahe, wie es nur möglich ist, ohne tatsächlich in Frankreich zu sein.
                    </div>

                    <div class="howto-title2">Ein „gottverlassenes“ Anwesen</div>
                    <div class="howto-text">
                        Franchetti ist ein ehemaliger Gastronom, Weinhändler und „vollständiger Trottel“ und Weinbauer
                        kleiner Prinz. Als er das Anwesen 1992 bepflanzte, beschreibt er es als „einen gottverlassenen Ort im Osten“.
                        des ersten Kalksteinberges nördlich von Rom mit einem ehemaligen Vulkan zwischen ihm und dem Meer“. Sei
                        Wie dem auch sei, die Lage des Anwesens in einem natürlichen Amphitheater schützt die Reben davor
                        schlechtem Wetter stand und ermöglicht es Franchetti, seine Früchte viel länger am Rebstock zu halten als seine anderen
                        supertoskanische Konkurrenten. Es ist diese lange Reifung, die der Tenuta di Trinoro so viel verleiht
                        komplexe Geschmacksschichten, die bei modernen Weinsammlern so beliebt sind.
                    </div>

                    <div class="howto-title2">Palazzi, Tenuta und Cupole</div>
                    <div class="howto-text">
                        Viele Weinkritiker der alten Schule beklagen das Ende seines Palazzi, einer schönen Mischung aus Merlot und
                        Cabernet Franc. Fantastisch beliebt in den USA (der 1998er gewann 93 von 100 Punkten).
                        „Amerikas Weinguru Robert Parker) stellte Franchetti 1999 mit der Produktion ein.“ Palazzi war weniger
                        komplex, warum also?“ er sagt. Offenbar ist ihm der Erfolg nicht herausfordernd genug. Tenuta
                        di Trinoro mag die Nummer eins des Weinguts sein, aber sein Zweitwein Le Cupole di Trinoro ist nicht halb so groß
                        auch schlecht. Basierend auf unserem Preis-Leistungs-Verhältnis ist dies ein schlechter 90er-Jahre-Score (fast konstant).
                        Wein bietet ein fantastisch gutes Preis-Leistungs-Verhältnis. Zunehmende Beliebtheit, wenn dies noch nicht der Fall ist
                        Wenn Sie etwas in Ihrem Portfolio haben, möchten Sie es vielleicht auf Ihren Tisch legen.
                        <br><br>
                        Wenn Ihr Herz jedoch immer noch der Tenuta gehört, beachten Sie, dass diese zu den teuersten gehört
                        Toscana IGT-Weine auf dem Sekundärmarkt. Erwarten Sie etwa 200 € pro Person
                        Flasche, deutlich höher als andere Weine der Region. Stand Q2 2019 war der Preis
                        im letzten Jahr stabil.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Tenuta di Trinoro</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec une belle allure de star de cinéma, un pedigree familial aussi long que le bras et un petit livre noir qui
                        bombé aux coutures, vous seriez pardonné de penser que le producteur de Tenuta di Trinoro Andrea Franchetti n'est pas votre viticulteur archétypal. Et pourtant, son vin phare Tenuta di Trinoro avait fait des légions d'amateurs. Un assemblage bordelais que "même les Bordelais admettent que c'est meilleur ici qu'à Bordeaux" Tenuta di Trinoro est aussi proche de xxxx que possible sans être en France.
                    </div>

                    <div class="howto-title2">Un domaine "abandonné"</div>
                    <div class="howto-text">
                        Ancien restaurateur, distributeur de vins et "complet dopehead", Franchetti est un viticulteur
                        petit-prince. En plantant le domaine en 1992, il le décrit comme «un endroit abandonné à l'est
                        de la première montagne calcaire au nord de Rome avec un ex-volcan entre elle et la mer». Être
                        quoi qu'il en soit, la situation du domaine en amphithéâtre naturel protège les vignes des
                        intempéries et permet à Franchetti de garder ses fruits sur la vigne beaucoup plus longtemps que ses autres
                        concurrents super toscans. C'est cette longue maturation qui donne à la Tenuta di Trinoro tant de
                        des couches complexes de saveurs, si appréciées des amateurs de vins modernes.
                    </div>

                    <div class="howto-title2">Palais, Tenuta et Cupole</div>
                    <div class="howto-text">
                        De nombreux critiques de vin de la vieille école déplorent la fin de son Palazzi, un bel assemblage de merlot avec
                        Cabernet franc. Fantastiquement populaire aux États-Unis (le 1998 a remporté 93 points sur 100 de
                        Le gourou du vin américain Robert Parker), Franchetti a cessé de produire cela en 1999. "Palazzi était moins
                        complexe, alors pourquoi le faire?» il dit. Apparemment, le succès n'est pas assez difficile pour lui. Tenuta
                        di Trinoro est peut-être le numéro un du domaine mais son second vin Le Cupole di Trinoro n'est pas à moitié
                        mal non plus. Un score bas des années 90 (presque systématiquement), basé sur notre qualité par rapport au prix, ce
                        le vin représente un excellent rapport qualité-prix. De plus en plus populaire si ce n'est pas encore le cas
                        dans votre portefeuille, vous voudrez peut-être l'envisager sur votre table.
                        <br><br>
                        Cependant, si votre cœur appartient toujours à la Tenuta, sachez qu'elle fait partie des plus chères.
                        Vins Toscana IGT sur le marché secondaire. Attendez-vous à payer quelque chose dans la région de 200 € par
                        bouteille, nettement plus élevé que les autres vins de la région. Au T2 2019, le prix avait été
                        stable au cours de la dernière année.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Tenuta di Trinoro</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With film-star good looks, a family pedigree as long as your arm and a little black book that is
                        bulging at the seams, you would be forgiven for thinking that Tenuta di Trinoro producer Andrea Franchetti is not your archetypal viticulturalist. And yet, his flagship wine Tenuta di Trinoro had gained legions of fans. A Bordeaux blend that “even the Bordelais admit it's better here than in Bordeaux” Tenuta di Trinoro is as close to xxxx as you can get without actually being in France.
                    </div>

                    <div class="howto-title2">A “godforsaken” estate</div>
                    <div class="howto-text">
                        A former restaurateur, wine distributor and “complete dopehead”, Franchetti is a viticultural
                        petit prince. Planting the estate in 1992, he describes it as “a godforsaken place on the east
                        of the first limestone mountain north of Rome with an ex-volcano between it and the sea”. Be
                        that as it may, the estate's location set in a natural amphitheatre protects the vines from
                        severe weather and allows Franchetti to keep his fruit on the vine much longer than his other
                        super-Tuscan competitors. It is this long ripening that gives the Tenuta di Trinoro so many
                        complex layers of flavours, that are so beloved by the modern wine collecting crowd.
                    </div>

                    <div class="howto-title2">Palazzi, Tenuta and Cupole</div>
                    <div class="howto-text">
                        Many old-school wine critics lament the end of his Palazzi, a lovely blend of Merlot with
                        Cabernet Franc. Fantastically popular in the US (the 1998 won 93 points out of 100 from
                        America's wine guru Robert Parker), Franchetti stopped producing this in 1999.”Palazzi was less
                        complex, so why do it?” he says. Apparently, success is not challenging enough for him. Tenuta
                        di Trinoro may be the estate's number one but its second wine Le Cupole di Trinoro is not half
                        bad either. A low nineties scorer (almost consistently), based on our quality vs. price, this
                        wine represents fantastically good value for money. Increasing in popularity if this is not yet
                        in your portfolio, you might want to consider it on your table.
                        <br><br>
                        However, if your heart still belongs to the Tenuta, note that it is among the highest-priced
                        Toscana IGT wines on the secondary market. Expect to pay something in the region of €200 per
                        bottle, significantly higher than other wines of the region. As of Q2 2019, the price had been
                        stable over the past year.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TenutaDiTrinoro",
    head: {
        title: 'Tenuta di Trinoro | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unique and premium wines of Tenuta di Trinoro, a renowned wine producer in Tuscany. Experience the passion, tradition, and innovation behind every bottle.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
